import { calibrationCard } from './calibration-card';
import { checkerboard } from './checkerboard';
import { colorBars } from './color-bars';
import { colorbars } from './colorbars';
import { crosshatch } from './crosshatch';
import { focusRings } from './focus-rings';
import { grid } from './grid';
import { grid1, grid1inverted } from './grid1';
import { grid2 } from './grid2';
import { none } from './none';
import { solid } from './solid';
import { source } from './source';
import { testCard } from './test-card';
import type { InputSource } from './types';
import { white } from './white';

export type { InputSource, InputSourceSetting, PatternDraw, ProjectionPattern } from './types';

export const inputSources: Record<string, InputSource> = {
  // Special
  solid,
  none,
  source,

  // Projector-style patterns
  grid,
  checkerboard,
  colorBars,
  focusRings,
  calibrationCard,

  // LED-style patterns (from canvasPatterns)
  grid1,
  grid1inverted,
  grid2,
  colorbars,
  crosshatch,
  white,

  // Full test card
  testCard,
};

// Legacy name map is no longer needed for the old LED pattern names
// since they are now direct entries in the registry.
// Keep this for any future remapping needs.
export const legacyNameMap: Record<string, string> = {};

export function resolveInputSource(name: string): InputSource {
  const resolved = legacyNameMap[name] || name;
  return inputSources[resolved] || inputSources['colorBars'];
}

// Keep backward-compat export for any existing consumers
export const patterns: Record<string, (ctx: CanvasRenderingContext2D, w: number, h: number) => void> =
  Object.fromEntries(Object.entries(inputSources).map(([k, v]) => [k, v.draw]));

export type PatternName = keyof typeof patterns;

export const defaultPatternName: PatternName = 'colorBars';
